/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventMicrophoneStatusSetFromJSON(json) {
    return StreemApiAnalyticEventMicrophoneStatusSetFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventMicrophoneStatusSetFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'roomSid': !exists(json, 'room_sid') ? undefined : json['room_sid'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}
export function StreemApiAnalyticEventMicrophoneStatusSetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'room_sid': value.roomSid,
        'enabled': value.enabled,
    };
}
//# sourceMappingURL=StreemApiAnalyticEventMicrophoneStatusSet.js.map